import React, { useState, useEffect } from "react";
import CustomTabLabel from "./CustomTabLabel";

// Componente che crea una cartella con tab personalizzati utilizzando la palette colori dinamica
export default function CustomFolder({ tabTitleArray, children, palette, className = '', initialTab = 0, onTabChange }) {
    const [selectedTab, setSelectedTab] = useState(initialTab);
    
    // Sincronizza lo stato interno con lo stato esterno quando initialTab cambia
    useEffect(() => {
        setSelectedTab(initialTab);
    }, [initialTab]);
    
    // Funzione per gestire il cambio tab
    const handleTabChange = (index) => {
        setSelectedTab(index);
        if (onTabChange) {
            onTabChange(index);
        }
    };
    
    return (
        <div className={`w-full ${className}`}>
            {/* LINEA TAB */}
            <div className="flex">
                {
                    tabTitleArray.map((tab, index) => (
                        <CustomTabLabel 
                            key={index} 
                            index={index} 
                            selectedTab={selectedTab} 
                            setSelectedTab={handleTabChange} 
                            title={tab}
                            palette={palette} 
                        />
                    ))
                }
            </div>
            
            {/* AREA TAB SELEZIONATA - senza titoli ripetuti, solo contenuto */}
            <div 
                className="w-full flex-1 flex flex-col" 
                style={{
                    background: palette.primaryBg || 'rgba(88, 129, 87, 0.314)', 
                    borderRadius: '0 0 12px 12px', 
                    padding: '24px',
                    height: 'calc(100% - 40px)'
                }}
            >
                {/* Mostra solo il children della tab selezionata */}
                {Array.isArray(children) ? children[selectedTab] : children}
            </div>
        </div>
    );
}
